import { PackingListDto } from '@pf/platform-wms/domain';
import { IAddressDto } from '@pf/shared-common';
import { asArraySafe } from '@pf/shared-utility';
import { LabelTemplates, PackingSlipLabelData } from './label-templates';
import { LabelType } from './label-types.enum';
import { PrintLabelOptions } from './print-options.model';

export interface BuildPackingSlipLabelsInput {
    packingLists: PackingListDto[];
    trackingNumber?: string | null;
    orderNumber?: string | null;
    shipTo?: IAddressDto | null;
    installAt?: IAddressDto | null;
    requestor?: string | null;
}

export function buildPackingSlipLabels(
    input: BuildPackingSlipLabelsInput
): PrintLabelOptions[] {
    const { packingLists } = input;
    if (!packingLists.length) {
        return [];
    }
    const trackingNumber = input.trackingNumber ?? '';
    const orderNumber = input.orderNumber ?? '';
    const shipTo = input.shipTo ?? null;
    const installAt = input.installAt ?? null;
    const requestor = input.requestor ?? null;
    const totalBoxes = packingLists.length;

    return packingLists.map((pkg, index) => {
        const itemsByDescription = new Map<string, number>();
        asArraySafe(pkg.packLines).forEach(pl => {
            const description = pl.bundle?.item?.name;
            if (description && pl.packedQuantity) {
                const current = itemsByDescription.get(description) ?? 0;
                itemsByDescription.set(
                    description,
                    current + pl.packedQuantity
                );
            }
        });
        const items = Array.from(itemsByDescription.entries()).map(
            ([description, quantity]) => ({ description, quantity })
        );
        const data: PackingSlipLabelData = {
            boxNumber: index + 1,
            totalBoxes,
            trackingNumber,
            orderNumber,
            items,
            shipTo,
            installAt,
            requestor,
        };
        return {
            barcode: `Packing Slip ${index + 1} of ${totalBoxes}`,
            tags: ['Packing Slip'],
            zpl: LabelTemplates[LabelType.PackingSlip](data),
        };
    });
}
